module.exports = __webpack_public_path__ + "img/scene2@2x.70de2b21.png";